// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChestController from "./chest_controller"
application.register("chest", ChestController)

import CoinController from "./coin_controller"
application.register("coin", CoinController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NoticeController from "./notice_controller"
application.register("notice", NoticeController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SessionController from "./session_controller"
application.register("session", SessionController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TokenController from "./token_controller"
application.register("token", TokenController)

import TokenDetailsController from "./token_details_controller"
application.register("token-details", TokenDetailsController)

import TokenRevealController from "./token_reveal_controller"
application.register("token-reveal", TokenRevealController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
